import React, { useState } from 'react';
import axios from 'axios';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/api/contact", formData);
      if (res.data.success) {
        setSubmitted(true);
      } else {
        alert("Message failed to send.");
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Something went wrong.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-sky-100 px-4 py-12">
      <h1 className="text-4xl font-bold mb-6 text-center">Contact Us</h1>

      {!submitted ? (
        <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-md w-full max-w-xl">
          <div className="mb-4">
            <label htmlFor="name" className="block font-semibold mb-1">Name</label>
            <input
              type="text"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="mb-4">
            <label htmlFor="email" className="block font-semibold mb-1">Email</label>
            <input
              type="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="mb-6">
            <label htmlFor="message" className="block font-semibold mb-1">Message</label>
            <textarea
              name="message"
              required
              rows="4"
              value={formData.message}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded"
          >
            Send Message
          </button>
		  <p className="text-sm text-gray-600 text-center mt-4">
            Or email us at <a href="mailto:contact@pscribes.com" className="text-blue-600 underline">contact@pscribes.com</a><br />
           📍 Hong Kong<br />
           🕒 Mon–Fri, 9AM–5PM (HKT)
          </p>
        </form>
      ) : (
        <div className="bg-white p-8 rounded-lg shadow-md text-center">
          <h2 className="text-2xl font-semibold mb-2">Thank you!</h2>
          <p>Your message has been sent. We'll get back to you soon.</p>
		  <p className="text-sm text-gray-600 mt-4">
            For urgent matters, contact us at <a href="mailto:contact@pscribes.com" className="text-blue-600 underline">contact@pscribes.com</a><br />
           📍 Hong Kong<br />
           🕒 Mon–Fri, 9AM–5PM (HKT)
          </p>
        </div>
      )}
    </div>
  );
};

export default Contact;
